import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { CourseListComponent } from './course-list.component';
import { FormsModule } from '@angular/forms';
import { SelectModule } from '../select';
import { CommonModule } from '@angular/common';
import { ShowMoreModule } from '../show-more/show-more.module';
import { FilteringModule } from '../filtering/filtering.module';
import { CourseItemModule } from '../course-item/course-item.module';

@NgModule({
    declarations: [CourseListComponent],
    exports: [CourseListComponent],
    imports: [CommonModule, FormsModule, SelectModule, ShowMoreModule, FilteringModule, CourseItemModule, TranslateModule]
})
export class CourseListModule {}
